"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var logo_1 = require("../../../constants/img/logo");
var AfterpayLogo = function () {
    return (0, preact_1.h)("img", { class: 'afterpay-logo', src: logo_1.AFTERPAY_LOGO, alt: 'afterpay' });
};
exports.default = AfterpayLogo;
